export default __webpack_public_path__ + "static/media/projects-9.1f45c87e.jpg";